import { gql } from "@apollo/client";

const get = gql`
  query clientContact($clientConsultantId: String!) {
    clientContact(input: { clientConsultantId: $clientConsultantId }) {
      id
      businessName
      logo
    }
  }
`;

const acceptInvitation = gql`
  mutation updateClientConsultantStatus($clientConsultantId: ID!, $status: ClientConsultantStatus!) {
    updateClientConsultantStatus(input: { clientConsultantId: $clientConsultantId, status: $status }) {
      id
      status
    }
  }
`;

export default {
  get,
  acceptInvitation,
}; 